import Module from '../../module';
import scroll from '../../../libs/scroll/scroll';

interface OptionsInterface {
	cssId: {
		anim?: {
			heHubPulsarsDiscoveryFusionImgTxtSectionColLeftCls: string;
			heHubPulsarsDiscoveryFusionImgTxtSectionColRightCls: string;
		}
	},

	slug: string
}

class Fusion extends Module {

	publicVars: OptionsInterface;

	constructor(options: OptionsInterface) {
		super('He Hub Pulsars Discovery Fusion Module');

		this.publicVars = options;
	}

	startup() {
		this.msg('startup');

		scroll.init();
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.heHubPulsarsDiscoveryFusionImgTxtSectionColLeftCls || '', 'he_hub_pulsars_discovery_fusion', { animCls: 'animate__zoomIn50P', once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.heHubPulsarsDiscoveryFusionImgTxtSectionColRightCls || '', 'he_hub_pulsars_discovery_fusion', { animCls: 'animate__fadeInRight25P', once: true});
	}

	bind() {
		this.msg('bind');
	}
}

export default Fusion;